import { API_BASE_URL } from "utils/constants";

const UserManagementPaths = {
  delete_user: `${API_BASE_URL}/auth/delete`,

  get_list_user: `${API_BASE_URL}/auth/users?:query`,

  update_user: `${API_BASE_URL}/auth/update`,

  update_status_user: `${API_BASE_URL}/auth/update_status`,

  create_new_user: `${API_BASE_URL}/auth/register`,

  get_departments: `${API_BASE_URL}/common/departments`,

  update_user_llm: `${API_BASE_URL}/common/update-user-llm`,

  update_user_configure: `${API_BASE_URL}/common/update-user-configure`,

  update_info_multi_user: `${API_BASE_URL}/auth/update-multi-users`,

};

export default UserManagementPaths;
